import { palette } from '../../../../styles/themes/vad/palette';
import { handleRegionFieldWithPipe } from '../../../utils/getDetailedPageTags';
export const getPreProcessedCardListData = items => {
  const cardItems = [];

  items &&
    items.length > 0 &&
    items.forEach(item => {
      const { link, name, image, spaTreatment, cuisine, mealType, suitableFor, region, location, priceTags, rating, num_reviews, rating_image_url } =
        item && item.fields ? item.fields : item;
      const itemUniqueKey = item.id.replace(/-/g, "");
      const tags = [];
      cuisine &&
        cuisine.length > 0 &&
        cuisine.forEach(
          tag =>
            tags.length < 2 &&
            tag &&
            tag.fields &&
            tag.fields.taxonomyValue &&
            tag.fields.taxonomyValue.value &&
            tags.push(tag.fields.taxonomyValue.value)
        );

      tags.length < 2 &&
        spaTreatment &&
        spaTreatment.length > 0 &&
        spaTreatment.forEach(
          tag =>
            tags.length < 2 &&
            tag &&
            tag.fields &&
            tag.fields.taxonomyValue &&
            tag.fields.taxonomyValue.value &&
            tags.push(tag.fields.taxonomyValue.value)
        );

      tags.length < 2 &&
        mealType &&
        mealType.length > 0 &&
        mealType.forEach(
          tag =>
            tags.length < 2 &&
            tag &&
            tag.fields &&
            tag.fields.taxonomyValue &&
            tag.fields.taxonomyValue.value &&
            tags.push(tag.fields.taxonomyValue.value)
        );

      tags.length < 2 &&
        suitableFor &&
        suitableFor.length > 0 &&
        suitableFor.forEach(
          tag =>
            tags.length < 2 &&
            tag &&
            tag.fields &&
            tag.fields.taxonomyValue &&
            tag.fields.taxonomyValue.value &&
            tags.push(tag.fields.taxonomyValue.value)
        );

      tags.length < 2 &&
        region &&
        region.length > 0 &&
        region.forEach(
          tag =>
            tags.length < 2 &&
            tag &&
            tag.fields &&
            tag.fields.taxonomyValue &&
            tag.fields.taxonomyValue.value &&
            tags.push(handleRegionFieldWithPipe(tag))
        );

      // Logic to turn priceTag range into expense meter
      const expenseValues = priceTags && priceTags.value;
      let expenseRange = '';
      if (expenseValues && expenseValues.length > 0) {
        const expenseRangeParam = [
          [1, 200],
          [201, 500],
          [501],
        ];
        const expenseRangeSigns = [
          '$',
          '$$',
          '$$$',
        ];
        const eachHighestNumb = [];
        expenseValues.forEach(value => {
          const breakVal = value.split(/[\ \-]/);
          const numbers = [];

          breakVal.forEach(val => {
            const isNumVal = parseInt(val);
            if (isNumVal) {
              numbers.push(isNumVal)
            }
          });
          eachHighestNumb.push(Math.max(...numbers));
        });
        const overAllHighest = Math.max(...eachHighestNumb);
        expenseRangeParam.forEach((range, index) => {
          if (!range[1]) {
            if (overAllHighest >= range[0]) {
              expenseRange = expenseRangeSigns[index];
            }
          } else {
            if (overAllHighest >= range[0] && overAllHighest <= range[1]) {
              expenseRange = expenseRangeSigns[index];
            }
          }
        });
      }

      cardItems.push({
        fields: {
          primaryCTA: {
            value: {
              href: link && link.value ? link.value : link,
            },
          },
          title: { value: name && name.value },
          attributeLabelCTA: [...tags],
          backgroundColor: {
            value: palette.common.White,
          },
          mobileImage: {
            ...image,
          },
          desktopImage: {
            ...image,
          },
          location: location && location.value,
          expenseRange,
          rating: rating && rating.value,
          num_reviews: num_reviews && num_reviews.value,
          rating_image_url: rating_image_url && rating_image_url.value,
          itemUniqueKey: itemUniqueKey
          // googlePlaceId: googlePlaceId && googlePlaceId.value,
        },
      });
    });
  return cardItems;
};
